import { render, staticRenderFns } from "./TheArtistSubscriptionPanel.vue?vue&type=template&id=04094764&scoped=true&"
import script from "./TheArtistSubscriptionPanel.vue?vue&type=script&lang=js&"
export * from "./TheArtistSubscriptionPanel.vue?vue&type=script&lang=js&"
import style0 from "./TheArtistSubscriptionPanel.vue?vue&type=style&index=0&id=04094764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04094764",
  null
  
)

export default component.exports